import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
// import { ClassificationDataProvider } from '../../../dataproviders/classification.dataprovider';
// import { Const } from '../../../static/const';
// import { ClassificationReport } from '../../../models/classification-report.model';
// import { HttpService } from '../../../services/http.service';
import { IraResultComponent } from './ira-result.component';
import { HttpService } from '../../services/http.service';
import { ClassificationDataProvider } from '../../dataproviders/classification.dataprovider';
import { ClassificationReport } from '../../models/classification-report.model';
import { Const } from '../../static/const';

@Injectable({
  providedIn: 'root',
})
export class IraResultService {
  constructor(
    private http: HttpClient,
    public httpClient: HttpService,
    private classificationDataProvider: ClassificationDataProvider
  ) {}

  uploadReport(classificationReport: ClassificationReport): Observable<void> {
    return this.classificationDataProvider.uploadReport(classificationReport);
  }

  getTableData() {
    // const url = '../../../assets/temp-data/IraTableData.json';
    const url = '../../../assets/temp-data/ira-table-data-full.json';
    return this.http.get(url);
  }
  populateOverallResult(data) {
    const url = Const.connectionUrl + '/api/populate_results';

    return this.http.post(url, data);
  }

  saveAsPDF(pdf: any) {
    const data = {
      doc_id: localStorage.getItem('docId'),
      session_id: sessionStorage.getItem('sessionId'),
      file: pdf.split(',')[1],
      type: 'pdf',
      product_id: localStorage.getItem('product'),
      country_id:
        localStorage.getItem('geography') == 'null'
          ? ''
          : localStorage.getItem('geography'),
      environment: localStorage.getItem('environment'),
    };
    const url = Const.connectionUrl + '/api/save_as';

    return this.http.post(url, data);
  }

  saveAsExcel(excel: any) {
    const data = {
      doc_id: localStorage.getItem('docId'),
      session_id: sessionStorage.getItem('sessionId'),
      file: excel.split(',')[1],
      type: 'xlsx',
      product_id: localStorage.getItem('product'),
      country_id:
        localStorage.getItem('geography') == 'null'
          ? ''
          : localStorage.getItem('geography'),
      environment: localStorage.getItem('environment'),
    };
    const url = Const.connectionUrl + '/api/save_as';

    return this.http.post(url, data);
  }

  checkGlobalClaimLA(data) {
    const url = Const.connectionUrl + '/api/check_global_claims_la';
    return this.http.post(url, data);
  }

  private hasiraConfirm = new BehaviorSubject<boolean>(false);
  supportSubstantiationRedirect$ = this.hasiraConfirm.asObservable();

  setiraConfirmChanges(value: boolean) {
    this.hasiraConfirm.next(value);
  }
  getiraConfirmChanges(): boolean {
    return this.hasiraConfirm.getValue();
  }
}
